import data_control from "../../../../../engines/libs/data_control";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MilitaryKind } from "../../../../define/MilitaryKind";
import MilitaryNewOfficerData from "./MilitaryNewOfficerData";
import MilitaryOfficerData from "./MilitaryOfficerData";

export default class MilitaryOfficerDataManage {

    militaryOfficerData = new MilitaryOfficerData();
    // militaryNewOfficerData = new MilitaryNewOfficerData();
 
    loadLocationData() {
        this.militaryOfficerData.loadLocalData();
        // this.militaryNewOfficerData.loadLocalData();
    }

    saveAllLocationData() {
        this.militaryOfficerData.saveLocalData();
        // this.militaryNewOfficerData.saveLocalData();
    }

    getOfficeList(bFroce: boolean = false) {
        let curDate = data_control.getCurrDateDayString();
        let militaryOfficerData = this.militaryOfficerData;
        if (bFroce || militaryOfficerData.lastRefreshDate != curDate) {
            militaryOfficerData.lastRefreshDate = curDate;
            militaryOfficerData.curOfficerList = [];

            let count = MilitaryKind.GeneralValue.EVERY_REFRESH_OFFICER_COUNT;
            let resuidueList = this.getResidueOffice();
            let maxCount = Math.min(count, resuidueList.length);
            if (maxCount > 0) {
                let randList = data_control.randomIntNum(0, resuidueList.length-1, count);
                for (let o of randList) {
                    militaryOfficerData.curOfficerList.push(resuidueList[o]);
                }
            }

            militaryOfficerData.saveLocalData();
        } 
        return militaryOfficerData.curOfficerList;
    }

    getResidueOffice() {
        let residueIdList: string[] = [];

        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.OFFICER);
        for (let i in csvInfo) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let data = this.militaryOfficerData.lists.get(i);
            if (data && !data.bDrop) {
                continue;
            }
            residueIdList.push(i);
        }
        return residueIdList;
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {
        
    }

}
